export const LOAD_GROUP_CONTENTS = 'LOAD_GROUP_CONTENTS'
export const LOAD_GROUP_CONTENTS_SUCCESS = 'LOAD_GROUP_CONTENTS_SUCCESS'
export const LOAD_GROUP_CONTENTS_FAIL = 'LOAD_GROUP_CONTENTS_FAIL'
export const LOAD_GROUP_CONTENTS_NEXT = 'LOAD_GROUP_CONTENTS_NEXT'
export const LOAD_GROUP_CONTENTS_NEXT_SUCCESS =
  'LOAD_GROUP_CONTENTS_NEXT_SUCCESS'
export const LOAD_GROUP_CONTENTS_NEXT_FAIL = 'LOAD_GROUP_CONTENTS_NEXT_FAIL'
